import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { disableFocusManager, restoreFocusManager } from './utils/focusManagerWorkaround';

// Disable focus manager before any React rendering happens
disableFocusManager();

// Wait for DOM to be ready
const renderApp = () => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // After React has rendered, wait a bit more for DOM to stabilize
    setTimeout(() => {
      // Restore original addEventListener behavior
      restoreFocusManager();
    }, 500);

    reportWebVitals();
  }
};

// Check if the document is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
